import styled from 'styled-components';
import { Link } from './styles';

const StyledLink = styled(Link)`
  cursor: pointer;
  text-decoration: underline;
  font-size: 16px;
`;

interface Props extends React.ComponentPropsWithoutRef<'a'> {
  children: React.ReactNode;
}

export const LinkWithRoleButton = ({ children, ...htmlProps }: Props) => (
  <StyledLink role="button" {...htmlProps}>
    {children}
  </StyledLink>
);
